import React, { useEffect } from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import {
  FormikSubmitDispatchProps,
  InvoicingProfileForm,
  InvoicingProfile,
  mainRootState,
  SelectFieldOption
} from "../../../redux/types";
import InvoicingProfileNewForm from "../../../components/invoices/invoicingProfiles/InvoicingProfileNewEditForm";
import * as RestActions from "../../../redux/sagas/restActions";
import { RestStrings, ReduxActionStrings } from "../../../redux/strings";
import { mapTabRouteProps } from "../../../helpers/routesHelper";

interface NewInvoicingProfileContainerProps
  extends FormikSubmitDispatchProps<InvoicingProfileForm> {
  loadCompanies: (searchTerm?: string) => void;
  companyOptions: SelectFieldOption[];
}

interface mapDispatchToPropsProps
  extends FormikSubmitDispatchProps<InvoicingProfile | InvoicingProfileForm> {
  loadCompanies: (searchTerm?: string) => void;
}

const NewInvoicingProfileContainer: React.FC<
  NewInvoicingProfileContainerProps
> = (props) => {
  const { loadCompanies } = props;

  useEffect(() => loadCompanies(), [loadCompanies]);
  return (
    <InvoicingProfileNewForm
      companyOptions={props.companyOptions}
      handleSubmit={props.handleSubmit}
      loadCompanies={props.loadCompanies}
      {...mapTabRouteProps(props)}
    />
  );
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: any
): mapDispatchToPropsProps => ({
  handleSubmit: (values, actions) => {
    const checkedNullValues = {
      ...values
    };
    actions.setSubmitting(false);
    dispatch(
      RestActions.restRequestWithData<InvoicingProfileForm>(
        ownProps.tabId,
        RestStrings.POST,
        ReduxActionStrings.INVOICINGPROFILE,
        "invoices/invoicingprofiles/",
        checkedNullValues as InvoicingProfile,
        "/invoices/invoicingprofiles?same_tab=true"
      )
    );
  },
  loadCompanies: (searchTerm?: string) => {
    dispatch(
      RestActions.restRequest(
        ownProps.tabId,
        RestStrings.GET,
        ReduxActionStrings.COMPANIES,
        `companies/companies/?filter__status=ACTIVE&page=1&page_size=10&include=["id","name"]&filter__name__icontains=${
          searchTerm || ""
        }`
      )
    );
  }
});

const mapStateToProps = (state: mainRootState, ownProps: any) => ({
  companyOptions: state.tabStates[
    ownProps.tabId
  ].companies.companies.companies.map((company) => ({
    label: company.name,
    value: company.id
  }))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewInvoicingProfileContainer);
